import { render, staticRenderFns } from "./HO210Fields.vue?vue&type=template&id=5bfb3c52"
import script from "./HO210Fields.vue?vue&type=script&lang=ts"
export * from "./HO210Fields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports